<template>
  <div class="content" >
    <WebHeader menu='5' ></WebHeader>
    <div class="web-page">
      <div id="benImg" class="imgdiv">
        <img src="static/img/schoolEnrollment/bannerTop.jpg" fill>
      </div>

  <!-- US202402025 修改文本 招聘流程 -> 共创医疗未来    -->
      <div class="block-title spacing1">
        <div></div>
        <div>共创医疗未来</div>
        <div></div>
      </div>
      <!--US202402025 zhangwenixng start 招聘流程图删除，新增3个渐变色块-->
      <div>
        <el-row  style="padding: 0"   >
          <el-col style="padding: 0" v-for="(o, index) in gpsData" :key="index"   :span="8">
            <el-card :body-style="{height:'100%',width:'100%'}" class="gpsCard" >
              <div style="padding: 50px 0 30px 10px; margin:0 auto ">
                 <p  class="gpsCardTitle1">{{ o.title1 }}</p>
                 <p  class="gpsCardTitle2">{{ o.title2 }}</p>
              </div>
              <div style="padding: 0 10px 0 10px" >
                <p class="gpsCardText">{{ o.text }}</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <!--US202402025 zhangwenixng end 招聘流程图删除，新增3个渐变色块-->

      <div class="block-title spacing2">
        <div></div>
        <div>管 培 生 项 目</div>
        <div></div>
      </div>
      <div class="projectAll">
        <!---->
        <!--/*US202408111	校招职位模块 - “管培生项目”标题下显示的文本内容修改 */-->
        <p class="projectBottomTxt" style="letter-spacing:0.5px;" >
          GE医疗管理培训生项目是应届毕业生进入GE医疗的主要途径，助力年轻人才与GE医疗一同快速成长。通过2-3年在不同部门进行颇具挑战性的轮岗和一系列的培训，在公司各重要职能部门中不断提高工作技能，并得到全方位的领导力锻炼，在职业生涯的早期奠定坚实的基础。
          <br>
          <br>
          目前，GE医疗有超过25％的高层管理者来自于这些管理培训生项目。
        </p>
        <div class="projectAllTwo"  >
          <el-button  >
            <div class="underline0"  @click="clickApply()">立即投递</div>
          </el-button>
        </div>
      </div>
      <div class="project" >
        <div class="projectOne"v-for="(item, index) in projectList" :key="index" :style="{'background-image' : 'url(' + item.url + ')'}">
        <div class="click" >
         <div class="projectTop">
            <img src="static/img/schoolEnrollment/projectLogo2.png" fill>
            <div class="projectTop2">{{item.title}}</div>
            <div class="projectTop3">{{item.firstLevel}}</div>
            <div class="projectTop4">{{item.secondLevel}}</div>
          </div>
        </div>
          <!--US202308055	增加部分管培生项目（子项）“立即申请”按钮-->
         <div class="projectBottom">
             <p class="projectBottomTxt">{{item.center}}</p>
       <!--  US202402025 取消增加部分管培生项目（子项）“立即申请”按钮-->
<!--           <el-button v-if="item.projectUrl">
                <div class="underline1" @click="projectApply(item.projectUrl )">立即申请</div>
               </el-button>-->

         </div>

        </div>


      </div>


<!--      <div class="block-title spacing3">
        <div></div>
        <div>日常实习生</div>
        <div></div>
      </div>
      <div class="intern">
        <div class="internTop">
          <div class="internTopTxt">
            <img class="rcImg"  src="static/img/schoolEnrollment/internLogo2.png">
            <p class="rcText">
              日常实习生
            </p>
          </div>
        </div>
        <div class="internBottom" >
          <div class="internBottomTxt">
            <div class="internP1">身在象牙塔，心在大世界。来GE医疗成为一名日常实习生，为你打开通往更大世界的一扇门。</div>
            <el-button @click="internship()">
              <div class="underline2">立即申请</div>
            </el-button>
          </div>

        </div>

      </div>-->

      <!-- 走马灯 开始 -->
      <div class="carousel-back">
        <div class="carousel-block newBlock">
           <!-- <el-carousel class="elCarousel" style="height: auto !important;" trigger="click" arrow="always" id='qaCarousel1' :autoplay="false">
              <el-carousel-item v-for="(item,pageIndex) in qaListOne" :key="pageIndex">
                <div class="carousel-text" style="height: auto !important; margin: 278px auto 88px auto;">

                    <div class="carousel-q">
                      <div><span class="carousel-text-q">Q:</span></div>
                      <p>{{item.q}}</p>
                    </div>
                    <div class="carousel-a">
                      <div><span  class="carousel-text-a">A:</span></div>
                      <p>{{item.a}}</p>
                    </div>

                </div>
              </el-carousel-item>
            </el-carousel>-->
          <el-carousel trigger="click" arrow="always" id='qaCarousel' :autoplay="false">
            <el-carousel-item v-for="(page,pageIndex) in qaList" :key="pageIndex">
              <div class="carousel-text">
                <div v-for="(item,index) in page" :key="index">
                  <div class="carousel-q">
                    <div><span class="carousel-text-q">Q:</span></div>
                    <p>{{item.q}}</p>
                  </div>
                  <div class="carousel-a">
                    <div><span  class="carousel-text-a">A:</span></div>
                    <p>{{item.a}}</p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
         <!-- <el-carousel trigger="click" arrow="always" id='qaCarousel'>
            <el-carousel-item v-for="(page,pageIndex) in Math.ceil(this.qaList.length/2)" :key="pageIndex">
              <div class="carousel-text">
                <div v-for="(item,index) in qaList.slice(((page-1)*2),page*2)">
                  <div class="carousel-q">
                    <div><span class="carousel-text-q">Q:</span></div>
                    <p>{{item.q}}</p>
                  </div>
                  <div class="carousel-a">
                    <div><span  class="carousel-text-a">A:</span></div>
                    <p>{{item.a}}</p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>-->
        </div>
      </div>
      <!-- 走马灯 结束 -->
 </div>
    <top-button></top-button>
    <WebFooter></WebFooter>
<!--    <WebLoading></WebLoading>-->
  </div>
</template>
<script>
 /* window.onload = function () {
    document.getElementById("pageLoading").remove();
  }*/
  import TopButton from "../../components/web/topButton";

 const Q_A = [
   /*1*/
   [ {q:'[商业领导力管理培训生项目] CLP的职业发展前景和职业路径是怎么样的？',
     a:'CLP的职业前景以Commercial方向为主，呈“之”字型向上的职业发展路径，优秀的CLP未来有机会在业务部门的不同Commercial职位得到进一步的锻炼和晋升。'
   },
     /*US202509025 lmg  文本内容修改
                          原:  为GE未来的*/
     {q:'[商业领导力管理培训生项目] Commercial Leadership Program (CLP)商业领导力管理培训生项目是一个什么样的program？',
      a:'CLP是致力于培养优秀的职场新人成长为GE医疗未来的商业领袖的管理培训生项目，通过一个预轮岗(Pre-assignment)及两个为期各一年的在销售、产品销售等不同职能颇具挑战的轮岗和一系列商务培训课程，项目成员能够具备并不断提升商务工作核心技能，全方位锻炼领导力，并为长远职业发展奠定坚实的基础。'
    },

     {q:'[商业领导力管理培训生项目] CLP轮岗的是跨地区还是固定一个地区？',
       a:'CLP轮岗有可能在全国各地进行，在结束轮岗并且达到毕业标准的CLP，公司将结合业务需要和个人实际意愿情况进行定岗安排。CLP需具备更高的灵活性配合公司的安排。'
     }],
  /*2*/
    [{q:'[商业领导力管理培训生项目] 每个轮岗之间是固定好的吗？还是需要自己寻找?',
      a:'根据每位CLP项目成员自身的特点，及业务需求，由资深的项目管理人员和人力资源伙伴及业务经理一起规划，为每位CLP成员匹配最适合的发展路径。'
    },
      /*US202509025 lmg  文本内容修改
                          原:  GE被业内称为“黄埔军校”，很大一部分原因就是因为各项培训体系非常完善。针对不同的阶段有不同的培训，提供给大家。*/
      {q:'[商业领导力管理培训生项目] CLP管培生会有系统的培训吗？具体有哪些？',
      a:'GE医疗的各项培训体系非常完善。针对不同项目的不同阶段有全方位的培训提供给大家。比如说NSP（新销售培训），市场创值基础以及后续一系列涵盖领导力、销售、市场、产品等方面的培训课程。'
    },
      {q:'[商业领导力管理培训生项目] CLP的项目设置和轮岗的工作岗位都有哪些？',
        a:'CLP项目包括一个Pre-assignment 和两个轮岗的设置，其中轮岗会发生在后面的两年左右。轮岗中会涉及到销售、产品销售等相关工作，同时须通过绩效考核，帮助CLP成员在商业领域得到全面和快速的成长。'
      }],
   /*3*/
    [
      {q:'[商业领导力管理培训生项目] CLP在应聘者的性格、能力方面会有哪些要求呢？',
        a:'CLP 需要候选人有较强的主动性，出色的沟通能力，良好的学习能力，分析能力，领导力和团队协作能力，脚踏实地的工作、以结果为导向，同时对商业环境的工作充满激情，渴望“赢”,并且勇于迎接挑战，面试过程中，主要的考量依据是应聘者在面试过程中做了哪些具体的分析以及沟通交流的能力，而非应聘者在此过程中承担的角色或语言表达的频繁度。'

      },
      /*US202509025 lmg  文本内容修改
                          原:  只要是在2022年10月至2023年7月之间毕业的在校生，不限专业，要求本科及以上学历，医学、生物医学工程、商科等相关专业优先。*/
      {q:'[商业领导力管理培训生项目] CLP候选人申请有什么要求吗？',
        a:'只要是符合毕业时间要求的在校生均可申请。学历要求本科及以上，专业不限，医学、生物医学工程、商科等相关专业优先。'
      },
      {q:'[商业领导力管理培训生项目] 入职时间一定要在7月吗？',
      a:'因为有些院校，比如海外的大学，毕业时间跟国内不一致。大多数同学的入职时间为每年的4月或者7月，以便于后续培训及assignment的安排。个别同学毕业时间不同可灵活安排。'
    }],
   /*4*/
    [{q:'[商业领导力管理培训生项目] CLP一定要轮岗吗？',
      a:'轮岗是CLP作为管培生项目的设定机制，使应届生们对真实的商业环境有大致的了解，并快速的理解业务对商务人员的需求，团队间的配合、及寻找适合自身的发展定位。因为GE医疗在commercial方向一直秉承人员的“之”字型发展路线，有不同岗位的经验是非常必要的；且虽然同为商务岗位不同的岗位侧重点不一样，看问题的角度不一样，轮岗可以使发展更加全面。'
    },
      /*US202509025 lmg  文本内容删除 */
      // {q:'[生产运营管理培训生项目] OMDP会有出国培训或工作的机会吗？',
      //   a:'就等国外疫情好转，培训火速安排！工作机会的话，请期待吧。'
      // },
      /*US202509025 lmg  文本内容修改
                          原:  OMDP*/
      {q:'[生产运营管理培训生项目] OMLP项目是否必须是物流或相关专业？对专业知识是否有较高要求？',
        a:'OMLP面向具有工科背景的优秀毕业生招聘。只要你对生产运营有热情， 具有好奇心和快速学习的能力，不要犹豫快到碗里来！'
      }],
   /*5*/
    [{q:'[生产运营管理培训生项目] OMLP轮岗是跨地区还是固定某个地方？',
      a:'跨地区的， 北京、天津、无锡、上海。'
    },
      {q:'[生产运营管理培训生项目] OMLP期间，英语交流所占的比例有多少？良好的英文沟通能力是否能够帮助我们更好的理解和胜任工作？',
        a:'日常工作会接触很多的外国供应商和客户，需要你用英语来表达。平时同事之间的邮件沟通有时也习惯用英文。接触的各类工作相关的文件也是英文为主。OMLP的培训当然是全英文的啦！良好的英语沟通能力会对工作有很大的帮助。'
      },

      {q:'[生产运营管理培训生项目] OMLP轮岗的工作岗位都有哪些，轮岗大约进行多久？',
        a:'OMLP在两年轮岗中会涉及到生产运营中相关岗位，比如：Manufacturing Engineer, Quality Engineer, Supervisor, Supplier Quality Engineer, Material, Project Leader等等。每个轮岗8个月， 两年内完成3个轮岗。'
      }],

   /*6*/
    [ {q:'[生产运营管理培训生项目] OMLP的职业发展前景和职业轨迹是怎么样的？',
      a:'OMLP的职业前景那可是一片光明，很多OMLP项目毕业的前辈已经成长为GE医疗的杰出领导者，下一个就是你了！职业轨迹的话就因人而异了， 一般会向Operation, Lean, Engineering, Project, Sourcing, Commercial Ops等这几个方向发展。'
    },
      {q:'[信息技术管理培训生项目] ITDP轮岗是跨地区还是固定某个地方？',
        a:'ITDP轮岗主要在北京/上海进行，根据岗位以及项目需要会有一定的差旅，结束轮岗将结合业务需要和个人实际情况进行定岗。'
      },
      /*US202509025 lmg  文本内容修改
                          原:  GE非常*/
      {q:'[信息技术管理培训生项目] ITDP会有相关培训的机会吗？',
        a:'GE医疗非常重视对管培项目人才的培养，公司内部以及海外（远程）培训的资源都十分丰富。你可以在培训中获得前沿的科技知识，也能收获项目管理/沟通管理等软技能。'
      }],

    [
      /*US202509025 lmg  文本内容修改
                          原:  ITDP目的是发展和培养未来的GE IT领导人。对于IT相关专业的应届生来说，ITDP是你在GE最佳的事业起步点。你将在2年内完成3个极富挑战的轮岗，在每个轮岗中，你都能在GE HealthCare内部不同的团队负责一个真正的项目。与此同时，你也会得到IT和领导力方面的全面培训，帮助你迅速成长为相关领域的领袖。在GE HealthCare转型，走向互联网道路的新时期，Digital部门的成立也让小P们多了一份了解和学习Cyber, Customer Digital Experience, Data and Analytics等前沿技术的机会。*/
      {q:'[信息技术管理培训生项目] ITDP的项目设置是怎样的？',
        a:'ITDP目的是发展和培养未来的GE医疗IT领导人。对于IT相关专业的应届生来说，ITDP是你在GE医疗最佳的事业起步点。你将在2年内完成3个极富挑战的轮岗，在每个轮岗中，你都能在GE医疗内部不同的团队负责一个真正的项目。与此同时，你也会得到IT和领导力方面的全面培训，包括了解和学习Cyber, Customer Digital Experience，Data and Analytics 等前沿技术的机会，帮助你迅速成长为相关领域的领袖。'
      },
      /*US202509025 lmg  文本内容修改
                          原:  QRDP*/
      {q:'[质量法规管理培训生项目] QRLP在GE医疗有不同的业务区别吗？',
        a:'现在，QRLP只有在GE医疗提供培养计划。将会在生命关爱事业部和医疗设备都有涉及。'
      },
      {q:'[质量法规管理培训生项目] QRLP是否有海外轮岗？',
        a:'除非公司有具体/特殊的安排，一般不安排海外轮岗。'
      }],
   /*8*/
    [{q:'[质量法规管理培训生项目] QRLP将会有哪些培训？',
      a:'除了用人经理分配的任务之外，候选人也会接受强化商业分析和领导力等相关课程。此外，QRLP需要参与GE医疗领导力举办的圆桌论坛。'
    },
      {q:'[质量法规管理培训生项目] QRLP招聘流程如何？',
        a:'请通过GE医疗官网或者“GE医疗招聘”公众号投递，我们会经过简历筛选，电话面试，面谈等形式进行。具体流程参照官方宣传网页。'
      },
      {q:'[质量法规管理培训生项目] QRLP轮岗中从事什么样的工作？',
        a:'QRLP的职责范围将集中在质量保证，监管事务，供应商质量管理，QMS 合规性和/或全球审计等等。具体将按照轮岗用人经理分配任务所定，但是都会是具备挑战性的任务，也会和高层经理进行合作。'
      }],

   /*9*/

    [{q:'[财务管理培训生项目] 在面试（特别是群面）过程中，是否会更倾向于录用作为leader的那个人？',
      a:'面试过程中，主要的考量依据是应聘者在这个面试过程中做了哪些具体的分析以及沟通交流的能力，而非应聘者在此过程中承担的角色或语言表达的频繁度。'
    },
      /*US202509025 lmg  文本内容修改
                          原:  FMDP*/
      {q:'[财务管理培训生项目] 申请FMP需要考取CPA或ACCA等相关证书吗？会支持成功应聘者考取这类证书吗？',
        a:'FMP对于CPA、CFA、AICPA等都没有特别要求，FMP在项目中会有完整的培训课程，并不要求额外的学习培训，当然有专业的证书会在未来的工作和FMP课程学习中提供扎实的基础。'
      } ,
      {q:'[财务管理培训生项目] 两年轮岗之后如何定岗？有哪些可供选择的岗位方向？',
      a:'定岗的选择是双向的，会根据FMP自己的意愿和公司岗位的情况确定岗位。岗位会分布在不同的业务部门，涉及不同的业务部门和财务部门不同的职能岗位，每年可供选择的岗位都是变化的。'
    }],
   /*10*/
    [ {q:'[财务管理培训生项目] 该项目对于应聘者的英语能力会有怎样的要求？',
      a:'应聘者要能够流利、顺畅地进行听、说、读、写。'
    },
      {q:'[财务管理培训生项目] FMP在应聘者的性格、能力方面会有哪些要求呢？',
        a:'FMP需要候选人有较强的主动性和抗压能力，出色的分析能力，良好的学习能力，交流能力，领导力和团队协作能力。'
      },
      {q:'[财务管理培训生项目] 在招聘时更看重哪些素质呢？对GPA有要求吗？没有相关实习经历，成功拿到offer可能性大吗？',
        a:'在面试过程中，出色的沟通能力与中英文表达能力非常重要。同时，团队协作能力、快速学习能力和自我驱动与管理能力也是非常重要的。较高的GPA、相关的实习或项目经验可能会成为应聘者的一种优势，因为这其中能反应一定的学习能力或专业基础，或者为FMP候选人所需要的能力提供了具体的实例，但这些都不是最终决定应聘者去留的关键因素。应聘者在面试过程中的表现才是能否进入FMP项目的关键。'
      }],

   /*11*/
    [
      {q:'[爱迪生工程技术管理培训生项目] EEDP的项目内容和特点是什么？',
        a:'轮岗：2年项目，3个轮岗。参加实际研发项目，学习开发流程、质量管理、技术与市场的结合、深入理解客户需求等实际工作能力，有机会发表论文发表专利或者看到自己的设计成为产品。 在实际工作中得到专家的具体指导。并且，可以在轮岗过程中找到非常感兴趣的技术领域，作为长期深入发展的方向。培训：第一年的A-Course （各个业务领域的技术重点）30+门课程，第二年的B- Course （系统设计方法论、创新实践等）15~20门课程，另外还有自主实践的小组项目，全面提升技术水平与业务能力； 另外还有公司专门设计的领导力培训，得到hard skill与soft skill的平衡发展。各种机会：参加EEDP各种 兴趣小组/俱乐部活动，参与组织公司内外的公益活动，锻炼组织能力、沟通能力，拓展视野，结识各路专家牛人。总之，EEDP的各种培训和工作安排旨在全面而迅速地提升综合素质和解决实际问题的能力，为在技术路线的长远发展做好坚实的准备。'
      },
      {q:'[爱迪生工程技术管理培训生项目] EEDP毕业后定岗如何安排？',
        a:'定岗也是双向选择，一般会去自己以前轮岗过的部门，选择适合自己长期发展兴趣、并有适合自己岗位的部门。'
      }],

   /*12*/
   /*US202509025 lmg  文本内容删除*/
    [{q:'[爱迪生工程技术管理培训生项目] EEDP适合哪些同学？',
      a:'有意愿在技术领域长期发展，并且英语能力和各项综合素质不错的同学，希望在一个大的平台不断学习新技术，不断钻研创新的同学，理工科专业的硕士学位在读生； GE医疗招收的专业方向非常广泛：机械、电气、软件、计算机工程、生物医学工程、工程物理、等等， 具体专业要求请参见GE医疗招聘网站上的EEDP 招聘职位说明。'
    },
      {q:'[爱迪生工程技术管理培训生项目] GE医疗在中国的研发会涉及核心技术吗？',
      a:'GE医疗在中国的研发团队已经有三十多年的发展历程，具备世界一流研发中心的核心能力，涉及各个领域的高精尖技术，也拥有系统级的自主研发创新能力，'+
        '完全可以积极参与到为中国客户定制适合本土市场的产品。'
    },],
   /*13*/
    [
      {q:'[爱迪生工程技术管理培训生项目] GE医疗对于学生的英文有怎样的要求？英文不是很好，但正在努力的同学有机会吗？',
        a:'GE医疗是跨国公司，在工作中不可避免地需要与世界各地的同事交流，所以在英语的综合运用能力上（听说读写）有一定的要求。当然，同学们也不要望而却步，自信是最重要的！在面试时，能用英语表达出自己的想法，并能进行简单的沟通即可。在未来的工作中，多听、多说、多练习，有更多使用英语的环境，相信同学们的英语一定能够突飞猛进。现在，就请加强提高英语的交流能力，增加自己胜出的机会吧！'
      },
      {q:'[爱迪生工程技术管理培训生项目] 上下班交通是否方便？',
        a:'北京无锡上下班均有多条班车线路可供选择。'
      }
      ,
      {q:'[爱迪生工程技术管理培训生项目] EEDP是正式员工吗？薪资福利如何？',
        a:'EEDP是GE医疗的正式员工，提供具有市场竞争力的薪资福利。'
      }
    ],
   /*14*/
    [

      {q:'[爱迪生工程技术管理培训生项目] EEDP在每个岗位主要做些什么工作？有机会参与重要项目吗？',
        a:'EEDP每个轮岗的工作内容由各部门具体安排，可能会涉及可行性研究方向的项目，或者大型新产品开发项目，或者参与解决客户反馈的问题，视部门情况而定。EEDP项目在GE医疗历史悠久，拥有成熟的经验和管理流程，不会安排EEDP成员从事无关紧要的工作，而是期待EEDP同学充分发挥各自的能力和潜质，勇于承担重任，并且在完成工作的同时有重点地提高各自的专业技术水平、各项综合素质。有相当多的EEDP成员在轮岗期间表现优异，取得发明专利，或受到各类表彰。'
      },
      {q:'[爱迪生工程技术管理培训生项目] 北京和无锡在工作内容和方向上有什么区别？',
      a:'北京的研发中心主要负责研发医院影像科用的大设备，比如CT，MR, X光等。无锡的研发主要包括临床科室用到的医疗设备，比如超声、监护仪、心电图、麻醉机等等。（超声又包含Primary Care、 CVUS心脏超声、ABUS乳腺超声、Platform等，所以供轮岗选择的产品线还是很丰富的）。'
    },],


   /*15*/
    [{q:'[爱迪生工程技术管理培训生项目] 工作作息怎么样，加班多吗？',
      a:'北京：不打卡，弹性工作时间，无锡：八点半到五点半。根据各部门任务安排，可能会有些加班的情况，但不严重，大部分时候都可以正常下班，只要上班认真完成工作。'+
        '公司的文化提倡工作生活的健康平衡，不提倡无效的加班。'
    },{q:'[爱迪生工程技术管理培训生项目] 软件背景完全没有生物医学工程背景，会影响之后的工作吗？',
      a:'不会的，大家各自都有自己的专业背景，不可能面面俱到。其它跨学科的专业基础知识可以在日后的工作当中不断积累，公司也会有相应背景的专家提供培训，以及公司内部其他可供学习的资源也非常多，后期是有很多学习提升的机会的。'
    },
      {q:'[爱迪生工程技术管理培训生项目] GE医疗在中国的研发会涉及核心技术吗？',
        a:'GE医疗在中国的研发团队已经有三十多年的发展历程，具备世界一流研发中心的核心能力，涉及各个领域的高精尖技术，也拥有系统级的自主研发创新能力，完全可以积极参与到为中国客户定制适合本土市场的产品。'
      }],
   /*16*/

   /*17*/
    [  {q:'[爱迪生工程技术管理培训生项目] EEDP的宗旨是什么？',
      a:'EEDP旨在吸收最具发展潜质的年轻工程技术人才，帮助他们在职业生涯的早期迅速提升专业技术水平、创新能力以及领导能力等综合才能。培养目标是成为GE医疗未来的研发骨干、精英（或者是CTO方向，或者是Chief Engineer这样的技术领军人才）。'
    }, {q:'[爱迪生工程技术管理培训生项目] 有没有国外轮岗的机会？',
      a:'目前大部分的轮岗安排在国内，也有部分国外轮岗或出差工作的机会。 具体要看工作安排。不过， EEDP非常强调全球化的合作经验，通过培训、活动等机会创造与全球团队工作的机会，接触不同文化、学习跨文化沟通。'
    },
      {q:'[爱迪生工程技术管理培训生项目] EEDP的工作地点在哪里？',
        a:'北京，无锡。'}
    ],

    [{q:'[爱迪生工程技术管理培训生项目] 不同专业的学生如果成为医疗集团的EEDP，主要会从事哪些方面的工作？',
      a:'不同专业背景的同学可以参与我们不同研发岗位的工作，比如： 软件、计算机工程类专业的同学：可以参与医疗产品的软件开发、平台设计、人机交互设计、智能设备研发等工作； 电气工程专业的同学：可以从事电路设计，还有可能涉及嵌入式设计、固件编程等工作。 生物医学工程、算法开发、图像处理等专业的同学：在医疗成像、系统设计、人工智能应用等领域大有可为。 机械工程专业的同学：可以参加结构设计、精密仪器设计、建模与分析等工作。'
    },
      {q:'[爱迪生工程技术管理培训生项目] EEDP选择轮岗岗位的时候，根据个人意向选了就可以过去吗？轮岗部门怎么选择？',
        a:'主要属于双向选择： 结合个人意向，也要了解各部门的项目需求，从而确定合适的岗位。当然感兴趣的岗位可以毛遂自荐，项目经理也会帮助大家和各部门沟通，选择合适的岗位。另外也有以业务部门为主导的模式，有些岗位（如系统工程师）制定了清晰的长期人才发展规划，也欢迎感兴趣的EEDP加入，在某一个特定岗位上深入发展。'
      }],

    [{q:'[爱迪生工程技术管理培训生项目] EEDP的工作之余的文化生活丰富吗？',
      a:'当然，我们会有定期的团建活动，此外，公司举办的各类活动也非常欢迎EEDP加入一起出谋划策。可以参加EEDP各种兴趣小组/俱乐部活动（学习小组，篮球俱乐部，羽毛球俱乐部，户外俱乐部等等），参与组织公司内外的公益活动，锻炼组织能力、沟通能力，拓展视野，结识各路专家牛人。'
    },{q:'[爱迪生工程技术管理培训生项目] EEDP会有哪些轮岗？',
      a:'根据业务需要和重要性，结合个人的专业和兴趣，轮岗选择可能包括：系统设计，技术分析，软件或硬件设计，质量控制，可靠性设计，系统集成和测试等等。轮岗的主要目的是快速学习， 加强技术深度与广度的拓展，并且认清自己的发展兴趣、优势与潜能，促进职业发展 。通常，不会有硬件、软件之间大幅度跨专业的轮岗设置，除非有EEDP同学想特意这样挑战不熟悉的领域—轮岗可以允许有很大的试错空间，可以定制个性化的项目任务，支持个性化的成长目标。'
    }],
    [
      {q:'[爱迪生工程技术管理培训生项目] 软件、计算机、数据分析、算法等热门专业，在医疗领域有什么应用空间？是否合适申请？',
      a:'我们非常欢迎这类专业方向的同学加入EEDP，因为医疗行业正在全面进入数字化、智能化时代，而且GE医疗是医疗数字化的行业引领者，我们在软件、AI 等方向的人才需求越来越大，这些相关背景的同学也会有非常大的发展空间，能够帮助我们让医疗设备更加智能，更好地服务于人类的健康。'
    },

      {q:'[爱迪生工程技术管理培训生项目] EEDP和普通工程师岗位有什么区别？',
        a:'EEDP除了参与研发工作之外，还会有一些针对EEDP的培训课程需要完成，包括技术培训，以及各种领导力基础和软技能方面的培训；另外，还有比较丰富的各种活动去参加或者去组织。这些，都是为了锻炼项目成员各方面的综合技能，为未来发展到更高的职业阶段做好充分准备。'
      }],

    [{q:'[爱迪生工程技术管理培训生项目] EEDP毕业后在公司的晋升空间有多大？',
      a:'EEDP是GE医疗培养未来工程技术领域骨干人才的重要项目，是未来CTO（技术总监）和Chief Engineer（总工程师）的摇篮。EEDP是公司为内部培养的技术人才，其对公司文化的了解程度、以及通过轮岗机制对公司产品的熟悉程度会比一般工程师更全面，接触的资源也更丰厚，往往晋升的速度是相对更快的。'
    },
      {q:'[爱迪生工程技术管理培训生项目] EEDP选择的轮岗一定要和自身专业相关吗？EEDP可以跨专业轮岗吗？',
        a:'通常是很相关的，但也不一定都必须如此。如果软件背景的同学对硬件部门感兴趣，也可以选择硬件部门轮岗。我们平时所设置的课程中，也会涉及到产品的软、硬件等方面，帮助大家综合学习。这是一个技术深度与广度的问题，个人的情况不同，要具体来看。'
      },

    ],
    [
      {q:'[爱迪生工程技术管理培训生项目] EEDP毕业后会从事什么样的工作？EEDP今后的发展方向是管理岗还是技术岗？',
        a:'EEDP培训生毕业后，会加入GE医疗的研发部门，成为成熟的能力全面的研发工程师。有许多的EEDP毕业生在各自的岗位迅速成长，正在担当高级工程师、系统总设计师、研发项目经理、研发部门经理等重要职位。定岗后的发展方向，可根据自身潜力、兴趣、机会等综合来看是技术方向还是管理方向，更多取决于个人的选择和机遇。'}
    ,{q:'[爱迪生工程技术管理培训生项目] 什么样的学位成功入选EEDP的机会更大？',
      a:'EEDP成员多为硕士研究生，也有少量博士毕业生，主要看岗位需要。GE医疗研发团队期待基础扎实，又有工程项目或科研经验的人才。如果作为本科生，你认为自己的学习能力、创造力、项目经验等不比硕士逊色，我们也非常欢迎你加入。果断投简历吧，并且在简历里面特别强调你的强项。有能力，就有机会。'
    }],
   [
     {q:'[爱迪生工程技术管理培训生项目] 轮岗时可以有多大的岗位选择空间？',
       a:'EEDP在轮岗时可跨产品部门进行轮岗，也可在同一产品部门的不同团队或项目选择轮岗。由于产品线区别较大，北京无锡两地轮岗是相对独立的，也都有足够的轮岗机会来选择。我们公共的课程会一起上，也会有很多共同交流的机会。具体轮岗内容有较大的弹性空间，有定制的机会。'
     }
    ,
     {q:'[爱迪生工程技术管理培训生项目] 对硕士期间的研究方向有要求么？',
       a:'在研究方向上没有特定的要求，如果申请人有相关研发项目经验会有一定的优势。 对于专业背景，我们还是希望有扎实的相关专业技术基础的，详见职位要求信息。同时，我们也看重学生的学习能力、创造力、沟通能力、团队精神、解决问题能力等方面的综合素质。'
     }]
  ]

    export default {
        name: "SchoolEnrollment",
      components: {TopButton},
      data() {
        return {
          bannerHeight:"",
          qaList:Q_A,
          projectList: [
            {
              /*US202509025 lmg  文本内容修改
                          原:  业务管理高层领导力培训生项目*/
              title: '业务管理高阶领导力培训生项目',
              firstLevel:'Business Management ',
              secondLevel:'Leadership Program,简称BMLP',
              url: require('../../../static/img/schoolEnrollment/BMLP1.jpg'),
              projectUrl:"http://campus.51job.com/gehc/",
              center:'BMLP是一项培养未来业务领导者和商业领袖的人才项目，通过选拔顶尖的全日制MBA毕业生的新领导力进入有挑战性的轮岗，接受优秀的领导者和同行指导并一起工作学习，我们将激发你的潜力，助力你获得启发和成长。',
            },
            {
              title: '商业领导力管理培训生项目',
              firstLevel:'Commercial Leadership ',
              secondLevel:'Program,简称CLP',
              url: require('../../../static/img/schoolEnrollment/CLP2.jpg'),
              projectUrl:"http://campus.51job.com/gehc/",
              center:' CLP是为公司培养未来商业领导人的管培项目。通过一个预轮岗及两个为期各一年的在销售、产品销售等跨职能、跨地区的轮岗，以及通过涵盖领导力、销售、市场、产品等诸多培训课程，使项目成员全方位了解产品、行业和客户， 具备并不断提升销售、产品、应用培训方面的技能，全方位锻炼领导力，为长远职业发展奠定坚实基础。',
            },
            {
              title: '爱迪生工程技术管理培训生项目',
              firstLevel:'Edison Engineering',
              secondLevel:'Development Program,简称EEDP',
              url: require('../../../static/img/schoolEnrollment/EEDP3.jpg'),
              projectUrl:"http://campus.51job.com/gehc/",
              center:'EEDP是为GE医疗培养未来的技术精英、技术领军者的培训生项目。通过两年在不同部门颇具挑战的轮岗和一系列丰富的技术和领导力培训课程，项目成员能够具备优秀工程技术人才的综合素质，并在职业早期加速提升技术研发工作核心技能，全方位锻炼领导力，为长远职业发展奠定坚实的基础。',
            },
            {
              /*US202509025 lmg  文本内容修改
                          原:  Development Program,简称FMDP*/
              title: '财务管理培训生项目',
              firstLevel:'Financial Management',
              secondLevel:'Program, 简称FMP',
              url: require('../../../static/img/schoolEnrollment/FMDP4.png'),
              projectUrl:"http://campus.51job.com/gehc/",
              center:'FMP始建于1914年，迄今已开展百年之久，是GE医疗老牌领导力培训项目。项目提供世界一流的培训课程和在各个业务部门中深度学习的机会，坚持培训与实践并行，资深导师全程带教，致力于人才发展，通过合理的岗位设计和优质的培训课程，发展领导力，提升分析能力，为未来培养有能力的财务领导者，助力于管培生的长足发展和成功。',
            },

            /*US202402025 ,zhangwenxing start 文本内容修改 ,
            Information Technology -> Digital Technology ',
            ITDP- > DTDP  */
            {
              title: '信息技术管理培训生项目',
              url: require('../../../static/img/schoolEnrollment/ITDP5.jpg'),
              firstLevel:'Information  Technology ',
              secondLevel:'Development Program,简称ITDP',
              center:'ITDP以发展和培养未来的IT领导人为目的，作为公司CIO的摇篮在业界享有盛誉。对于IT相关专业的应届生来说，ITDP是你在GE医疗理想的事业起步点。你将在2年内完成3个极富挑战的轮岗，在每8个月的轮岗中，都有机会在不同的业务集团负责一个真正的项目。同时，你将得到IT和领导力方面的全面培训，帮助你迅速成长为相关领域的领导者。',
            },
            /*US202402025 ,zhangwenxing end 文本内容修改 ,
            Information Technology -> Digital Technology ',
            ITDP- > DTDP  */

            /*US202402025 zhangwenxing 部分文案修改
                  	生产运营管理培训生项目  改为  生产运营管理领导力项目
                  	Operations Management Development Program 改为Operations Management Leadership Program
                  	OMDP  改为 OMLP
            *  */
            {
              title: '生产运营管理领导力项目',
              firstLevel:'Operations Management ',
              secondLevel:'Leadership Program,简称OMLP',
              url: require('../../../static/img/schoolEnrollment/OMDP6.png'),
              projectUrl:"http://campus.51job.com/gehc/",
              center:'OMLP旨在培养全球化供应链运营管理人才。通过两年供应链内不同职能部门挑战性的三个轮岗和GE医疗全球标准化培训，项目成员能够掌握供应链前沿核心知识，全方位锻炼领导力，并能应对GE医疗全球供应链带来的各种挑战。为项目成员在职业生涯的早期，奠定坚实的基础。',
            },
            {
              title: '质量法规管理培训生项目',
              firstLevel:'Quality & Regulatory',
              secondLevel:'Leadership  Program,简称QRLP',
              url: require('../../../static/img/schoolEnrollment/QRDP7.jpg'),
              center:'QRLP是为寻求质量保证和监管事务职位的高潜力人才准备的项目。项目学员将在质量和法规团队内进行为期2年的3个轮岗。轮岗包括：质量保证、监管事务、生产和流程控制、投诉处理、纠正和预防措施、产品质量监控、设计质量控制、供应商质量管理、QMS 合规性和/或全球审计。',
            },
            {
              title: '卓越设备维护技术专家管理培训生项目',
              firstLevel:'Service Super Expert',
              secondLevel:'Program,简称SSEP',
              url: require('../../../static/img/schoolEnrollment/SSEP8.jpg'),
              center:'SSEP旨在培养医疗设备行业客户服务技术人才。通过四年内在多个职能部门进行有挑战性的轮岗和全球标准化培训，项目成员能掌握医疗设备领域前沿产品技术及全面的客户服务运营管理体系知识，学习先进的远程诊断数字维修工具和技术，快速成长为医疗设备行业售后服务技术专家，全方位提升行业敏感度，在职业生涯早期奠定坚实基础。',
            },
          ],

          /*US202402025 zhangwenxing start 招聘流程图删除, 改为三个色块, gpsData:管培生 下方色块内容*/
          gpsData:[
            {  title1:"人文关爱", title2:"Make care more human", text:"我们所做的一切以人性化目标为出发点。   面对医疗从业者和患者，我们首先要以人为本，让医疗关爱尽可能人性化、定制化和富有同情心。",},
            {  title1:"激发创想", title2:"Ignite bold ideas",    text:"每天，我们都在努力让医疗关爱变得更好。这意味着我们要支持大胆的创意、从未实施过的解决方案和难以想象的变革。",},
            {  title1:"聚力成长", title2:"Together we thrive",   text:"我们是一个包容的团队，每个个体的差异都将帮助我们取得成功。我们也是一群拼搏者，重视想象力、好奇心和协作精神，全力完成我们的使命。",}
          ],
          /*US202402025 zhangwenxing end 招聘流程图删除, 改为三个色块, gpsData: 管培生 下方色块内容*/
        }
      },
      methods: {
        clickApply(){
          /*US202408111 zhangwenxing start  立即投递 按钮链接 由 http://campus.51job.com/gehc2025 改为 https://app.mokahr.com/campus-recruitment/gehc/142250*/
          window.open("https://app.mokahr.com/campus-recruitment/gehc/142250",'_blank');
          /*US202408111 zhangwenxing end  立即投递 按钮链接 由 http://campus.51job.com/gehc2025 改为 https://app.mokahr.com/campus-recruitment/gehc/142250*/

        },
        imgLoad () {
          this.$nextTick(() => {
            if(this.$refs.bannerHeight){
              this.bannerHeight = this.$refs.bannerHeight[0].height
              console.log(this.$refs)
            }
          })
        },
        /*项目申请实习申请页面跳转*/
        projectApply(link){
          console.log(link)
          if(link!=undefined){
            window.open(link,'_blank');
          }


        },
        internship(){
          window.open("https://jobs.gecareers.com/global/en/internship-co-op-jobs",'_blank');
        }
      },
      mounted () {
        this.imgLoad()
        window.addEventListener('resize', () => {
          this.bannerHeight = this.$refs.bannerHeight[0].height
          this.imgLoad()
        }, false)
      }
    }


</script>

<style scoped>




  .imgdiv{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .imgdiv img{
    width: 100%;
  }



  .spacing1{
    margin: 50px 0 66px 0px;
  }
  /*招聘流程*/
  .HiringProcess{
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    margin: 0px auto;
  }
  .HiringProcess img{
    width: 57.76vw;
    height: 19.84vw;
  }
  /*领导力管培项目*/
  .projectAll{
    margin: 0 auto;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    max-width: 1230px;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
  }
  .projectAll> p{
    margin: 0px 15px;
    font-size: 18px;
    font-weight: 400;
    color: #474747;
  }
  .projectAllTwo{
    margin: 0px auto;
    font-size: 18px;
    font-weight: 400;
    color: black;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items: center;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
  }
  .projectAllTwoTxt{
    color: #474747;
    margin-top: 10px;
    margin-right: 5px;
  }
  /*US202402025 zhangwenxing start 投递按钮 改为背景色为白色 文字颜色改为紫色 以及其他效果微调 */
  .projectAllTwo button{
    margin-top: 10px;
    padding: 0px;
    background-color:#FFFFFF ;
    font-size: 24px;
    font-weight: 600;
    color:#6400a0 ;
    cursor:pointer;
    height: 55px;
    /* padding: 10px 15px 10px 14px;*/
    padding: 8px 20px 5px 20px;
    border-radius: 26px;
    border: 2px solid #6400a0;
  }
  /*US202402025 zhangwenxing end 投递按钮 改为背景色为白色 文字颜色改为紫色 以及其他效果微调 */

  .underline0{
    padding-bottom: 2px;
    border-bottom: 2px solid transparent;
  }
  .project{
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    max-width: 1230px;
    justify-content: center;
  }
  .project > div{
    margin: 25px 15px;
  }

  .projectOne{
    width: 380px;
    height: 550px;
    background-color: #F8F8F8;
    box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.07);
    background-repeat: no-repeat;
    background-size: 380px 170px;
    background-position: top;
  }
  .projectTop{
    width: 361px;
    height: 115px;
    padding: 28px 0px 27px 19px;
    background-image: linear-gradient(to right, rgba(0,0,0,0.8), rgba(0,0,0,0));
  }
  .projectTop2{
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 36px;
  }
  .projectTop3{
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
  }
  .projectTop4{
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
  }
  .projectOne img{
   /* width: 38px;
    height: 39px;*/
    width: 167px;
    height: 39px;
  }
  .projectBottom{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 310px;
    height: 325px;
    padding: 30px 35px 25px ;
    align-items: flex-end;
  }
  .projectBottomTxt{
    font-size: 18px;
    font-weight: 400;
    color: #474747;
    line-height: 30px;
    display:-webkit-box;
    overflow:hidden;
    -webkit-line-clamp:9;
    -webkit-box-orient:vertical;
  }

    .project::after {
      content: '';
      width: 380px;
      margin: 25px 15px;
    }


  .projectBottom button {

    padding: 0px;
    background-color: #6400a0;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    cursor:pointer;


  }
  .projectBottom button{
   /* width: 100px;*/
    height: 36px;
    padding: 10px 15px 10px 14px;
    border-radius: 26px;
    border: none;

  }
  .el-button.is-round{
    border: none;
  }
/*  .el-button.is-round:hover .underline1{
    border-bottom: 2px solid white;
    padding-bottom: 2px;

  }*/
/*  .el-button.is-round:hover{
    background-color: #d2a1fa;
    color: #222222;

  }*/
  .spacing2{
    margin-top: 50px;
    /*US202308055	校招职位模块-移除“管培生项目”标题下显示的文本内容及按钮 布局调整*/
    margin-bottom: 15px;
  }








/*  日常实习生样式*/
  .spacing3{
    margin-top: 83px;
    margin-bottom: 70px;
  }

  .intern{
    width: 900px;
    height: 726px;
    margin:0px auto;
    background-color: #f8f8f8;
    background-image: url("../../../static/img/schoolEnrollment/intern.jpg");
    background-position: top;
    background-repeat: no-repeat;
    background-size: 900px 405px;
    margin-bottom: 197px;

  }

/*  .internTop{
    width: 841px;
    height: 185px;
    padding: 111px 0px 109px 59px;
    background-image: linear-gradient(to right, rgba(0,0,0,0.9), rgba(0,0,0,0));
  }*/
  .internTop{
    width: 900px;
    height: 405px;
    background-image: linear-gradient(to right, rgba(0,0,0,0.9), rgba(0,0,0,0));
  }
  .internTopTxt{
    width: 363px;
    height: 183px;
    padding: 113px 476px 109px 61px;
  }


  .rcImg{
    width: 363px !important;
    height: 100px;

  }

  .rcText{
    font-size: 50px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 36px;
    margin-top: 37px;

  }

/*  .internBottom{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 780px;
    height: 228px;
    padding: 58px 60px 38px 60px;
    align-items: flex-end;
  }*/
  .internBottom{
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    width: 900px;
    height: 321px;
    align-items: flex-end;
    -webkit-align-items: flex-end;
  }
  .internBottomTxt{
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    width: 780px;
    height: 225px;
    padding: 55px 60px 38px 60px;
    align-items: flex-end;
    -webkit-align-items: flex-end;
  }


  .internP1{
    font-size: 30px;
    font-weight: 500;
    color: #474747;
    line-height: 38px;
    margin-right: 112px;

  }
  .internBottomTxt button {
    padding: 0px;
    background-color: #6400a0;
    height: 60px;
    font-size: 28px;
    font-weight: 400;
    color: #FFFFFF;
    border-radius: 30px;
    line-height: 38px;
    padding: 0 30px;
    border: none;
  }
  .small {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .pic_item {
    position: relative;
    height: 100%;
  }
  .pic_item:hover{
    cursor: pointer;
  }

  .pic_item img {
    width: 100%;
    height: 100%;
  }

  .pic_item h3 {
    position: absolute;
    left: 1rem;
    bottom: 2rem;
  }
  #qaCarousel{
    display: block;
  }
 /* #qaCarousel1{display: none}*/
  .carousel-back .carousel-text{
    width: 83% ;
    height: 75%;
    margin: 108px auto 88px auto;
    /*margin: 5.6vw auto 5.6vw auto;*/
    font-size: 22px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .carousel-back .carousel-text .carousel-q > div{
    width: 4%;
  }
  .carousel-back .carousel-text .carousel-q > p{
    padding: 0 0 0 12px;
  }
  .carousel-back .carousel-text .carousel-a > p{
    width: 96%;
    padding: 0 0 0 12px;
  }
  .carousel-back .carousel-text .carousel-a{
    color: #5F5F5F;
    line-height: 36px;
    /*font-weight: 600;*/
    margin: 19px 0 51px 0;
    display: flex;
  }
  .carousel-back .carousel-text .carousel-q{
    color: #6400a0;
    line-height: 30px;
   /* font-weight: 600;*/
    display: flex;
  }
  .carousel-back .carousel-text .carousel-text-q{
    padding: 10px;
    background-color: #6400a0;
    color: #ffffff;
    font-size: 26px;
  }
  .carousel-back .carousel-text .carousel-text-a{
    padding: 13px;
    font-size: 26px;
  }
  .carousel-back .carousel-block{
    width: auto;
    height: 775px;
    margin: 197px auto 0 auto ;
  }


  #qaTile{
    display: none;
  }
  @media screen and ( min-width:668px )and (max-width: 781px) {
    .carousel-back .el-carousel__arrow{
      width: 40px;
      height: 40px;
      font-size: 40px;
    }
   /* .newBlock ul{
      display: none;
    }*/
  }
  /*按钮下划线调整*/
  @media screen and (min-width: 868px) {
    .projectBottom button:hover .underline1{
      border-bottom: 2px solid white;
      padding-bottom: 2px;

    }
    .projectAllTwo button:hover .underline0{
     border-bottom-color: #6400a0;


    }
    .internBottom button:hover .underline2{
      border-bottom: 2px solid white;
      padding: 5px 0 3px;

    }

    }

  /*招聘流程*/
  @media screen and (min-width: 1920px) {
    .HiringProcess img{
      width: 1109px;
      height: 381px;
    }

  }
  /*日常实习生1.7*/
  @media screen and (max-width: 1200px) {
    .intern{
      width: 79.69vw;
      height: 64.54vw;
      background-size: 79.69vw 35.85vw;
      margin-bottom: 17.44vw;

    }

   /* .internTop{
      width: 74.46vw;
      height: 16.38vw;
      padding: 9.83vw 0 9.65vw 5.22vw;
    }*/


    .internTop{
      width: 79.69vw;
      height: 35.858vw;
      background-image: linear-gradient(to right, rgba(0,0,0,0.9), rgba(0,0,0,0));
    }
    .internTopTxt{
      width: 32.14vw;
      height: 16.202vw;
      padding: 10vw 42.145vw 9.651vw 5.4vw;
    }



    .rcImg{
      width: 31.29vw !important;
      /*width: 8.94vw !important;*/
      height: 8.94vw;
    }

    .rcText{
      font-size: 4vw;
      line-height: 3.19vw;
      margin-top: 3.27vw;

    }
/*

    .internBottom{
      width: 69.06vw;
      height: 20.19vw;
      padding: 5.13vw 5.31vw 3.36vw 5.31vw;
    }
*/

    .internBottom{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 79.69vw;;
      height: 25.42vw;
      align-items: flex-end;
    }
    .internBottomTxt{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 69.062vw;
      height: 19.92vw;
      padding: 4.869vw 5.313vw 3.364vw 5.313vw;
      align-items: flex-end;
    }

    .internP1{
      font-size: 2.65vw;
      line-height: 4.36vw;
      margin-right: 9.91vw;

    }

    .internBottomTxt button {
      height: 5.36vw;
      font-size: 2.48vw;
      border-radius: 2.65vw;
      line-height: 3.36vw;
      padding: 0 10px;

    }


  }



  /**/
  @media screen and (max-width: 1024px) {
    #qaCarousel1{display: block}
 /*   #qaCarousel{
      display: none;
    }*/
    .newBlock{
      height: auto !important;width: auto !important;

    }
    .carousel-back .carousel-text{
      font-size: 18px;
    }

    .carousel-back .carousel-text .carousel-text-q{
      padding: 5px;
      background-color: #6400a0;
      color: #ffffff;
      font-size: 18px;
    }
    .carousel-back .carousel-text .carousel-text-a{
      padding: 5px;
      font-size: 18px;
    }
  }
  /*管培生项目简介适配*/
  @media screen and (max-width: 1164px) {
    .projectAll{
      max-width: 820px;
    }
  }
  @media screen and (max-width: 854px) {
    .projectAll{
      max-width: 604px;
    }
  }
  @media screen and (max-width: 732px) {
    .projectAll{
      max-width: 522px;
    }
  }
  @media screen and (max-width: 640px) {
    .projectAll{
      max-width:460px;
    }
  }
  @media screen and (max-width: 512px) {
    .projectAll{
      max-width:374px;
    }
  }
  @media screen and (max-width: 426px) {
    .projectAll{
      max-width:287px;

    }
    .projectAll> p{
      font-size: 12px;
    }

    .projectAllTwoTxt{
      font-size: 12px;
    }
    .projectAllTwo button{
      font-size: 12px;
      height: 22px;
      padding: 1px 3px 1px 3px;
    }
  }
  @media screen and (max-width: 414px) {
    .projectAll{
      max-width:310px;

    }
    .projectAll> p{
      font-size: 12px;
    }

    .projectAllTwoTxt{
      font-size: 12px;
    }
    .projectAllTwo button{
      font-size: 12px;
      height: 22px;
      padding: 1px 3px 1px 3px;
    }
    .underline0{
      border-bottom: none;
      padding-bottom: 0px;
    }
  }
  @media screen and (max-width: 390px) {
    .projectAll{
      max-width:290px;

    }
    .projectAll> p{
      font-size: 12px;
    }

    .projectAllTwoTxt{
      font-size: 12px;
    }
    .projectAllTwo button{
      font-size: 12px;
      height: 22px;
      padding: 1px 3px 1px 3px;
    }
  }
  @media screen and (max-width: 868px) {
    /*标题间距*/
    .spacing1{
      margin: 35px 0 65px 0px;
    }
    .spacing2{
      margin-top: 53px;
      margin-bottom: 8px;
    }
    .spacing3{
      margin-top: 34px;
      margin-bottom: 45px;
    }
    /*项目*/
    .project{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }
    .project > div{
      margin: 25px 15px;
    }

    .projectOne{
      width: 67.268vw;
      height: 97.41vw;
      background-size: 100% 30.1vw;
    }
    .projectTop{
      width: 63.99vw;
      height: 20.366vw;

      padding: 4.964vw 0px 4.78vw 3.06vw;

    }
    .projectTop2{
      font-size: 3.5vw;
      line-height: 6.3vw;
    }
    .projectTop3{
      font-size: 3.1vw;
      line-height: 3.8vw;
    }
    .projectTop4{
      font-size: 3.1vw;
      line-height: 3.8vw;
    }
    .projectOne img{
     /* width: 6.7vw;*/
      width: 29.96vw;
      height: 6.7vw;
    }
    .projectBottom{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 54.893vw;
      height: 57.55vw;
      padding: 5.3vw 6.1vw 4.4vw ;
    }
    .projectBottomTxt{
      font-size: 3.1vw;


      line-height: 5.3vw;
    }

    .project::after {
      content: '';
      width: 67.268vw;
      margin: 25px 15px;
    }

    .projectBottom button{
      /* width: 15.702vw;*/
      height: 6.375vw;
      font-size: 3.1vw;
      border-radius: 26px;
      padding: 4px 6px 3px 6px;
      /*  padding: 4px 8px 3px 8px;*/
    }

    .spacing2{
      margin-top: 86px;
      margin-bottom: 18px;
    }

    /* */
    .carousel-back .carousel-text .carousel-text-q{
      padding: 5px;
      background-color: #6400a0;
      color: #ffffff;
      font-size: 12px;
    }
    /**/
    .carousel-back .carousel-text{
      font-size: 12px;
    }
    /**/
    .carousel-back .carousel-text .carousel-text-a{
      padding: 5px;
      font-size: 12px;
    }

  }
  .carousel-back{
    width: 100%;
    background-color: #F3F3F3;
  }


</style>
<style>
 .carousel-back .el-carousel, .el-carousel__container{
    height: 755px !important;

  }

 .carousel-back .el-carousel__arrow{
    width: 77px;
    height: 77px;
    font-size: 40px;
  }
  .carousel-back .el-carousel__item > *{
    background: #F3F3F3;
  }

  .carousel-back .el-carousel__button {
    opacity: 1;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #CCCCCC;
  }
  .carousel-back .is-active .el-carousel__button {
    background-color: #6400a0;
  }
  .carousel-back .el-carousel__indicators {
    margin: 0 0 50px 0;
  }

 /* */
 @media screen and (max-width: 1024px) {
   .carousel-back .el-carousel__arrow{
     width: 40px;
     height: 40px;
     font-size: 40px;
   }
 /*  .newBlock ul{
     display: none;
   }*/
 }
 @media screen and (min-width: 852px) {
   .carousel-back .el-carousel__button{
     width: 11px !important;
     height: 11px !important;
   }
 }

 /**/
 @media screen and (max-width: 868px) {
   .carousel-back .el-carousel__arrow {
     width: 25px;
     height: 25px;
     font-size: 25px;
     /* min-height: 555px !important;*/
   }

 }
 @media screen and (max-width: 732px) {
   .newBlock ul{
     display: none
   }

 }

 /*US202402025 zhangwenxing start 取消招聘流程图 更换为三个渐变色块*/
 .gpsCard{
   border-radius: 20px;
   width: 350px;
   padding: 0;
   background: linear-gradient(to top, #F8F8F8, #ffffff);
   display: flex;
   justify-content: center;
   align-items: center;
   height: 280px;
   margin: 0 auto;
 }

 .gpsCardTitle1{
   margin: 0;
   font-size: 23px;
   font-weight: 700;
   color: #6400a0;
   letter-spacing:1px;
 }

 .gpsCardTitle2{
   letter-spacing:1px;
   margin: 0;
   font-size: 23px;
   font-weight: 700;
   color: #6400a0;
 }
 .gpsCardText{
   line-height:169% ; /*文字行间距*/
   width: 100%;
   white-space: pre-wrap; /* 或者使用 pre-line，根据具体需求 */
   font-size: 16px;
   font-weight: 700;
   color: #000000;
   margin-top: 4px;
   letter-spacing:2px;
 }

 .gpsDescriptionTxt{
   font-size: 18px;
   font-weight: 400;
   color: #474747;
   line-height: 30px;
   display:-webkit-box;
   overflow:hidden;
   -webkit-line-clamp:9;
   -webkit-box-orient:vertical;
 }

 .gpsDescriptionTxt{
   font-size: 3.1vw;


   line-height: 5.3vw;
 }
 /*US202402025 zhangwenxing end 取消招聘流程图 更换为三个渐变色块*/

</style>



// WEBPACK FOOTER //
// src/views/web/schoolEnrollment.vue